/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toggle_ColumnsInputs */

const en_table_toggle_columns = /** @type {(inputs: Table_Toggle_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle columns`)
};

const pt_br2_table_toggle_columns = /** @type {(inputs: Table_Toggle_ColumnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar colunas`)
};

/**
* | output |
* | --- |
* | "Toggle columns" |
*
* @param {Table_Toggle_ColumnsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_toggle_columns = /** @type {((inputs?: Table_Toggle_ColumnsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toggle_ColumnsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_toggle_columns(inputs)
	return pt_br2_table_toggle_columns(inputs)
});